import React from "react";
import Routes from "./Routes";
import Footer from "./components/ui/Footer";

function App() {
  return (
    <div className="min-h-[100dvh] flex flex-col bg-background">
      
      {/* Contenu principal */}
      <div className="flex-1">
        <Routes />
      </div>

      {/* Footer global */}
      <Footer />
    </div>
  );
}

export default App;
